module.exports = "/_next/static/images/4145dca5d0e652cc0cd295278dbd0ecc-woman-using-cellphone@1.5x.jpg";